import { supabase } from './lib/supabase.js';
import { AuthManager } from './auth/AuthManager.js';
import { DashboardManager } from './dashboard/DashboardManager.js';

class App {
  constructor() {
    this.authManager = new AuthManager();
    this.dashboardManager = new DashboardManager();
    this.currentUser = null;
    
    this.init();
  }

  async init() {
    // Check for existing session
    let session = null;
    try {
      const { data: { session: retrievedSession } } = await supabase.auth.getSession();
      session = retrievedSession;
    } catch (error) {
      console.warn('Failed to retrieve session, falling back to authentication:', error);
      
      // If the error is due to an invalid refresh token, clear the session
      if (error.message && error.message.includes('Refresh Token Not Found')) {
        try {
          await supabase.auth.signOut();
        } catch (signOutError) {
          console.warn('Failed to sign out during refresh token cleanup:', signOutError);
        }
      }
      
      session = null;
    }
    
    if (session) {
      this.currentUser = session.user;
      this.showDashboard();
    } else {
      this.showAuth();
    }

    // Listen for auth changes
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN') {
        this.currentUser = session.user;
        this.showDashboard();
      } else if (event === 'SIGNED_OUT') {
        this.currentUser = null;
        this.showAuth();
      }
    });
  }

  showAuth() {
    const app = document.getElementById('app');
    app.innerHTML = this.authManager.render();
    this.authManager.bindEvents();
  }

  showDashboard() {
    const app = document.getElementById('app');
    app.innerHTML = this.dashboardManager.render(this.currentUser);
    // Make the dashboard manager globally available for onclick handlers
    window.dashboardManager = this.dashboardManager;
    this.dashboardManager.bindEvents();
  }
}

// Initialize the app
new App();